export default "__VITE_ASSET__CeR0Df9U__"